import { render, staticRenderFns } from "./ReservedItem.vue?vue&type=template&id=b14cb060&lang=pug"
import script from "./ReservedItem.vue?vue&type=script&lang=js"
export * from "./ReservedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports